import { render, staticRenderFns } from "./EntityHistory.vue?vue&type=template&id=70e2cd28&"
import script from "./EntityHistory.vue?vue&type=script&lang=js&"
export * from "./EntityHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports